module.exports = __webpack_public_path__ + "img/4.ceef1168.png";